/* eslint-disable camelcase */
import axios from '@axios'

export const state = {
  top_up_requests: [],
  currentPage: 1,
  perPage: 15,
  totalPages: 1,
  totalRecords: 0,
  exporteds: [],
}

export const getters = {
  allRequests: (state) => state.top_up_requests,
  currentPage: (state) => state.currentPage,
  totalPages: (state) => state.totalPages,
  perPage: (state) => state.perPage,
  totalRecords: (state) => state.totalRecords,
  allExports: (state) => state.exporteds,
}

export const mutations = {
  GET_REPORTS: (state, data) => {
    if (!data) {
      state.reports = []
      state.currentPage = 1
      state.perPage = 15
      state.totalPages = 1
      state.totalRecords = ''
      return false
    }
    state.decryptedReports = []
    state.reports = data.reports
    state.reports.forEach((report) => {
      state.decryptedReports.push({
        id: report.id,
        decrypted: false,
        content: '',
      })
    })
    let { reports, page, perPage, totalPages, totalRecords } = data
    state.reports = reports
    state.currentPage = page
    state.totalPages = totalPages
    state.perPage = perPage
    state.totalRecords = totalRecords
  },
  GET_TOPUPS: (state, data) => {
    if (!data) {
      state.top_up_requests = []
      state.totalPages = 1
      state.currentPage = 1
      state.totalRecords = 0
      return false
    }
    let { topups, page, perPage, totalRecords, totalPages } = data
    state.top_up_requests = topups
    state.totalPages = totalPages
    state.currentPage = page
    state.totalRecords = totalRecords
    state.perPage = perPage
  },

  CREATE_TOPUP: (state, topup) => {
    state.top_up_requests.unshift(topup)
  },

  APPROVE_TOPUP: (state, topup) => {
    for (let i = 0; i < state.top_up_requests.length; i++) {
      if (state.top_up_requests[i].id === topup.id) {
        for (let field in topup) {
          state.top_up_requests[i][field] = topup[field]
        }
        break
      }
    }
  },

  REJECT_TOPUP: (state, topup) => {
    for (let i = 0; i < state.top_up_requests.length; i++) {
      if (state.top_up_requests[i].id === topup.id) {
        state.top_up_requests[i].status = topup.status
      }
    }
  },
  GET_EXPORT_REPORT: (state, data) => {
    state.exporteds = data
  },
  REMOVE_EXPORT_REPORT: (state, id) => {
    state.exporteds = state.exporteds.filter((c) => c.id !== id)
  },
  REMOVE_TOPUP: (state, data) => {
    let topups = state.top_up_requests.filter((topup) => {
      return topup.id !== data.id
    })
    state.top_up_requests = topups
  },

  UPDATE_TOPUP: (state, topup) => {
    for (let i = 0; i < state.top_up_requests.length; i++) {
      if (state.top_up_requests[i].id === topup.id) {
        for (let field in topup) {
          state.top_up_requests[i][field] = topup[field]
        }
        break
      }
    }
  },
}

export const actions = {
  async getTopups({ commit, dispatch }, params = {}) {
    dispatch('layout/changeLoading', true, { root: true })
    await axios
      .get(`/billing/topups`, { params: params })
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_TOPUPS', resp.data)
          dispatch('layout/changeLoading', false, { root: true })
        }
      })
      .catch(() => {
        commit('GET_TOPUPS', null)
        dispatch('layout/changeLoading', false, { root: true })
      })
      .finally(() => {
        dispatch('layout/changeLoading', false, { root: true })
      })
  },

  async getTopup({ commit }, topup) {
    return axios.get(`/billing/topup/${topup.id}`)
  },

  async createTopup({ commit }, topup = {}) {
    await axios
      .post(`/billing/topup`, topup)
      .then((resp) => {
        if (resp.status === 201) {
          commit('CREATE_TOPUP', resp.data)
        }
      })
  },
  async approveTopup({ commit, dispatch }, topup = {}) {
    dispatch('layout/changeLoading', true, { root: true })
    await axios
      .patch(`/billing/topup/approve`, topup)
      .then((resp) => {
        if (resp.status === 200) {
          let topup = resp.data
          commit('APPROVE_TOPUP', topup)
        }
      })
  },
  async rejectTopup({ commit, dispatch }, topup = {}) {
    await axios
      .patch(`/billing/topup/reject`, topup)
      .then((resp) => {
        if (resp.status === 200) {
          let topup = resp.data
          commit('REJECT_TOPUP', topup)
        }
      })
  },
  async removeTopup({ commit, dispatch }, topup) {
    await axios
      .delete(`/billing/topup/${topup.id}`)
      .then((resp) => {
        if (resp.status === 204) {
          commit('REMOVE_TOPUP', topup)
        }
      })
  },

  async updateTopup({ commit, dispatch }, topup) {
    await axios
      .put(`/billing/topup`, topup)
      .then((resp) => {
        if (resp.status === 200) {
          commit('UPDATE_TOPUP', resp.data)
        }
      })

  },
  async getExportReports({ commit, dispatch }) {
    await axios.get('/sms/reports/topup/exports', { params: { perPage: 15 } }).then((res) => {
      if (res.status === 200) {
        commit("GET_EXPORT_REPORT", res.data.reports)
      }
    })
  },
  async exportTopup({ commit, dispatch }, { params }) {
    dispatch('layout/changeLoading', true, { root: true })
    return axios.get(`/sms/reports/topup/export`, { params: params })
  },
  async getPaymentToken({ commit }, topup) {
    return axios.post('/billing/topup/payment-token', topup)
  },
}
